(() => {
  const normalize = (value) => (value || '')
    .toLocaleLowerCase('tr-TR')
    .replace(/\s+/g, ' ')
    .trim();

  const powerRules = [
    [/\b120\s*kw\b/i, '120 kW'],
    [/\b90\s*kw\b/i, '90 kW'],
    [/\b60\s*kw\b/i, '60 kW'],
    [/\b40\s*kw\b/i, '40 kW'],
    [/\b30\s*kw\b/i, '30 kW'],
    [/\b22\s*kw\b/i, '22 kW'],
    [/\b11\s*kw\b/i, '11 kW'],
    [/\b7[,.]4\s*kw\b/i, '7,4 kW'],
    [/\b3[,.]7\s*kw\b/i, '3,7 kW']
  ];

  const featureRules = [
    [/taşınabilir/i, 'Taşınabilir'],
    [/kablolu/i, 'Kablolu'],
    [/soketli/i, 'Soketli'],
    [/\bocpp\b/i, 'OCPP'],
    [/\brfid\b/i, 'RFID'],
    [/trifaze/i, 'Trifaze'],
    [/monofaze/i, 'Monofaze'],
    [/type\s*2/i, 'Type 2'],
    [/\b10\s*metre\b/i, '10 m'],
    [/\b7\s*metre\b/i, '7 m'],
    [/\b5\s*metre\b/i, '5 m']
  ];

  const getPowerLabel = (title) => {
    for (const [pattern, label] of powerRules) {
      if (pattern.test(title)) return label;
    }
    return '';
  };

  const getFeatures = (title, limit = 2) => {
    const found = [];
    featureRules.forEach(([pattern, label]) => {
      if (found.length < limit && pattern.test(title) && !found.includes(label)) {
        found.push(label);
      }
    });
    return found;
  };

  const enhanceCards = (root = document) => {
    root.querySelectorAll('.yv-product-card').forEach((card) => {
      const titleLink = card.querySelector('.yv-product-title');
      const info = card.querySelector('.yv-product-information');
      const imageBox = card.querySelector('.yv-product-card-img');
      if (!titleLink || !info) return;

      const titleText = titleLink.textContent || '';

      if (imageBox && !imageBox.querySelector('.sg-power-badge')) {
        const power = getPowerLabel(titleText);
        if (power) {
          const badge = document.createElement('span');
          badge.className = 'sg-power-badge';
          badge.textContent = power;
          imageBox.appendChild(badge);
        }
      }

      if (!card.querySelector('.sg-card-chips')) {
        const features = getFeatures(titleText);
        if (features.length) {
          const chips = document.createElement('div');
          chips.className = 'sg-card-chips';
          features.forEach((feature) => {
            const chip = document.createElement('span');
            chip.textContent = feature;
            chips.appendChild(chip);
          });
          titleLink.insertAdjacentElement('afterend', chips);
        }
      }

      if (!card.querySelector('.sg-card-cta')) {
        const offer = Array.from(card.querySelectorAll('.yv-prizebox')).some((priceBox) =>
          normalize(priceBox.textContent).includes('teklif')
        );
        const link = document.createElement('a');
        link.className = 'sg-card-cta';
        link.href = titleLink.href;
        link.innerHTML = `${offer ? 'Teklif Al' : 'Ürünü İncele'} <span aria-hidden="true">→</span>`;
        info.appendChild(link);
      }
    });
  };

  const mountProductDecision = () => {
    const template = document.querySelector('#sg-product-decision-template');
    const title = document.querySelector('.template_product .yv-main-product-detail .yv-product-detail-title');
    if (!template || !title || document.querySelector('.template_product .sg-product-decision')) return;
    title.insertAdjacentElement('afterend', template.content.firstElementChild.cloneNode(true));
  };

  const moveCollectionDescription = () => {
    const description = document.querySelector(
      '.collection-products-section > .container.sm-container .yv-collection-description'
    );
    if (!description) return;

    const section = description.closest('.collection-products-section');
    if (!section || section.querySelector('.sg-collection-about')) return;

    const details = document.createElement('details');
    details.className = 'sg-collection-about';

    const summary = document.createElement('summary');
    summary.textContent = 'Kategori hakkında';

    const content = document.createElement('div');
    content.className = 'sg-collection-about__content rich-editor-text-content';
    content.innerHTML = description.innerHTML;

    details.append(summary, content);

    const collectionContainer = section.querySelector('.yv-collection-container');
    if (collectionContainer) {
      collectionContainer.insertAdjacentElement('afterend', details);
    } else {
      section.appendChild(details);
    }

    description.closest('.container.sm-container')?.remove();
  };

  const localizeVisibleText = () => {
    document.querySelectorAll('input[placeholder="Aramak"]').forEach((input) => {
      input.placeholder = 'Ürün veya marka ara';
    });

    document.querySelectorAll('[data-loader-status]').forEach((status) => {
      status.textContent = 'Ürün sepetinize ekleniyor';
    });

    if (!document.body.classList.contains('template_product')) return;

    document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span').forEach((element) => {
      const value = normalize(element.textContent);
      if (value === 'ücretsiz kargo') {
        element.textContent = 'Kargo ve Teslimat';
      }
      if (value === 'tüm ürünlerde ücretsiz kargo avantajı') {
        element.textContent = 'Teslimat koşulları ürün ve adrese göre ödeme adımında gösterilir.';
      }
      if (value === 'teslim alma durumu yüklenemedi') {
        const pickup = element.closest('[data-pickup-availability], .pickup-availability, .product-pickup-availability');
        if (pickup) pickup.hidden = true;
      }
    });
  };

  const setupOfferAction = () => {
    document.querySelectorAll('[data-sg-open-offer]').forEach((button) => {
      if (button.dataset.sgBound === 'true') return;
      button.dataset.sgBound = 'true';
      button.addEventListener('click', () => {
        const productRoot = document.querySelector('.template_product .single__product');
        const details = productRoot?.querySelector('details');
        if (details) {
          details.open = true;
          details.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        window.location.href = '/pages/iletisim';
      });
    });
  };

  const init = (root = document) => {
    enhanceCards(root);
    mountProductDecision();
    moveCollectionDescription();
    localizeVisibleText();
    setupOfferAction();
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();

    const shouldObserve = document.body.classList.contains('template_collection')
      || document.body.classList.contains('template_search')
      || document.body.classList.contains('template_product');
    if (!shouldObserve) return;

    const target = document.querySelector('#MainContent');
    if (!target) return;

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        init(target);
        scheduled = false;
      });
    });

    observer.observe(target, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

(() => {
  if (!window.location.pathname.includes('/cart')) return;
  if (document.querySelector('script[data-sg-address-selects]')) return;
  const current = document.currentScript || Array.from(document.scripts).find((script) => script.src.includes('/assets/sg-uiux.js'));
  if (!current || !current.src) return;

  const assetUrl = new URL(current.src, window.location.href);
  assetUrl.pathname = assetUrl.pathname.replace(/sg-uiux\.js$/, 'sg-address-selects.js');
  assetUrl.searchParams.set('sgv', '20260801-1');

  const script = document.createElement('script');
  script.src = assetUrl.toString();
  script.dataset.sgAddressSelects = 'true';
  script.defer = true;
  document.head.appendChild(script);
})();
